/**
 * Cuantificación clínica sobre máscara N³ alineada al buffer HU Int16.
 * Volumen: nVox × (sx·sy·sz) en cm³, con sx,sy,sz el vóxel de la grilla 3D (mm).
 */

export function gridVoxelMm(volume) {
  if (!volume || !volume.size) return [1, 1, 1]
  const n = Math.max(1, volume.size | 0)
  const sp = volume.spacingMm || volume.spacing || [1, 1, 1]
  const dx = Math.max(1e-6, Number(sp[0]) || 1)
  const dy = Math.max(1e-6, Number(sp[1]) || dx)
  const dz = Math.max(1e-6, Number(sp[2]) || dy)
  const cols = Math.max(1, Number(volume.cols) || n)
  const rows = Math.max(1, Number(volume.rows) || n)
  const zDim = Math.max(1, Number(volume.zDim) || n)
  return [
    (cols * dx) / n,
    (rows * dy) / n,
    (Math.max(1, zDim - 1) * dz) / n,
  ]
}

/**
 * @param {Uint8Array} mask
 * @param {{ hu?: Int16Array, size?: number, spacingMm?: number[] }} volume
 * @param {{ minLabel?: number }} [opts]
 */
export function quantifyMaskHu(mask, volume, opts = {}) {
  const n = volume && volume.size ? volume.size | 0 : 0
  const empty = {
    count: 0,
    volumeCm3: 0,
    huMin: null,
    huMax: null,
    huMean: null,
    huStd: null,
    voxelMm: gridVoxelMm(volume),
  }
  if (!mask || !volume || !n || mask.length < n * n * n) return empty
  const hu = volume.hu
  const minLabel = opts.minLabel != null ? Number(opts.minLabel) : 1
  const [sx, sy, sz] = empty.voxelMm
  const voxCm3 = (sx * sy * sz) / 1000
  let count = 0
  let sum = 0
  let sum2 = 0
  let huMin = Infinity
  let huMax = -Infinity
  const len = n * n * n
  const hasHu = !!(hu && hu.length >= len)
  for (let i = 0; i < len; i++) {
    if (mask[i] < minLabel) continue
    count++
    if (!hasHu) continue
    const h = hu[i]
    sum += h
    sum2 += h * h
    if (h < huMin) huMin = h
    if (h > huMax) huMax = h
  }
  if (!count) return empty
  const mean = hasHu ? sum / count : null
  const variance = hasHu ? Math.max(0, sum2 / count - mean * mean) : 0
  return {
    count,
    volumeCm3: count * voxCm3,
    huMin: hasHu ? huMin : null,
    huMax: hasHu ? huMax : null,
    huMean: mean,
    huStd: hasHu ? Math.sqrt(variance) : null,
    voxelMm: [sx, sy, sz],
  }
}
